export default {
  email: "email@exemplo.com",
  yes: "Sim",
  no: "Não",
  allowed_extensions:
    "Extensões permitidas: .PDF, .PNG, .JPEG, .JPG, .DOC, .DOCX",
  max_size: "Tamanho máximo do arquivo 2 MB",
  min_one: "Selecione pelo menos um registro",
};
